import React, { useState } from "react";
import { Row, Col, Form, Input, Button, message } from "antd";
import { apiPostContactUs } from "api";

const Corporation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const onFinish = async (value) => {
    setIsLoading(true);
    try {
      const res = await apiPostContactUs(value);
      message.success("聯繫表單成功送出");
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div className="w-full pt-20 mb-20">
        <h3 className="mb-1">與Skyline Film合作</h3>
        <p className="text-SKF-G-002 m-0">
          Skyline film 提供客製化活動以及年度廣告合約的活動方式
        </p>
      </div>
      <div className="w-full pb-20">
        <Row>
          <Col
            sm={{ span: 10, offset: 1 }}
            xs={{ span: 22, offset: 1 }}
            lg={{ span: 8, offset: 3 }}
            className="mb-10 desktop:mb-0"
          >
            <div className="bg-[url('assets/corporation/left.png')] h-320 rounded-3xl"></div>
            <h4 className="text-left mb-0">客製化品牌專場</h4>
            <p className="text-left mt-0 text-SKF-G-001">
              藉由Skyline Film獨特的屋頂氛圍，來打造專屬於品牌的電影院吧!
            </p>
          </Col>
          <Col
            sm={{ span: 10, offset: 2 }}
            xs={{ span: 22, offset: 1 }}
            lg={{ span: 8, offset: 2 }}
          >
            <div className="bg-[url('assets/corporation/right.png')] h-320 rounded-3xl"></div>
            <h4 className="text-left mb-0">Skyline Film 年度廣告合約</h4>
            <p className="text-left mt-0 text-SKF-G-001">
              您將跟著屋頂電影院在北、高的自售場次活動進行巡迴，並與屋頂電影院的其他夥伴們一起與觀眾進行互動。
            </p>
          </Col>
        </Row>
      </div>
      <div className="w-full bg-SKF-G-001 px-4 desktop:px-56 py-6 desktop:py-12 tablet:px-20">
        <h4 className="text-left text-black">聯絡我們 Contact US</h4>
        <Form
          layout="vertical"
          name="contact"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col sm={{ span: 12 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "此欄位必填",
                  },
                ]}
              >
                <Input placeholder="name" size="large" className="p-2" />
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: "此欄位必填且需滿足email格式",
                  },
                ]}
              >
                <Input placeholder="email" size="large" className="p-2" />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "此欄位必填",
                  },
                ]}
              >
                <Input
                  placeholder="phone number"
                  size="large"
                  className="p-2"
                />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item
                name="content"
                rules={[
                  {
                    required: true,
                    message: "此欄位必填",
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 5,
                  }}
                  placeholder="content"
                  size="large"
                  className="p-2"
                />
              </Form.Item>
            </Col>
            <Col
              sm={{ span: 24, offset: 0 }}
              xs={{ span: 24, offset: 0 }}
              className="text-left"
            >
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="bg-black text-white py-2 px-5 h-auto"
                >
                  送出Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default Corporation;
